<!-- 
  jxc选择产品 组件
  供应商供货产品注意：去掉规格列，不展开多规格。用产品的父id
  prop: 
    productListSele: 父组件显示的产品
    attrValue: 绑定值
    explains: 表头
    saleExplains: 销售出库产品解释
    form: 提交时form表单数据对象
    showClassify: 产品分类是否显示
    nonEditable: 1 是否可编辑
    slectProBtn: 产品选择按钮状态
    fieldAttr:字段名
    BillId:单据ID
    productType:true且采购合同、合同、机会可重复选
    modal: true合同、合同、机会可重复选是否显示蒙版
    selectIdArr: 编辑过来已选产品ID
    item: 产品字段对象
  emit: 
    getProductList: 提交选中产品数据
 -->
 <template>
   <div class="selectProduct" :class="{required: item && !!item.required && ['finishedProduct', 'materiel'].indexOf(fieldAttr) === -1}">
      <template v-if="fieldAttr==='products'">
        <el-button type="text" :disabled="nonEditable === 1 || slectProBtn" @click="handleSelect()">
          <i class="el-icon-plus"></i>选择产品
        </el-button>
        <!-- 扫码产品 -->
        <scan-code
          :slectProBtn="nonEditable === 1 || slectProBtn"
          :fieldAttr="fieldAttr"
          :barcodeParams="barcodeParams" 
          @getProduct="handleSelect"
          @sendProduct="scancCodePro">
        </scan-code>
      </template>
      <template v-if="moduleName==='assemble'">
        <template v-if="fieldAttr === 'outProducts'">
          <el-button type="text" :disabled="nonEditable === 1  || getDisabled(fieldAttr)" @click="handleSelect()">
            <i class="el-icon-plus"></i>选择产品
          </el-button>
          <!-- 扫码产品 -->
          <scan-code
            :slectProBtn="nonEditable === 1  || getDisabled(fieldAttr)"
            :fieldAttr="fieldAttr"
            :barcodeParams="barcodeParams" 
            @getProduct="handleSelect"
            @sendProduct="scancCodePro">
          </scan-code>
        </template>
        <template v-else>
          <el-button type="text" :disabled="nonEditable === 1  || getDisabled(fieldAttr)" @click="handleSelect()">
            <i class="el-icon-plus"></i>选择产品
          </el-button>
          <!-- 扫码产品 -->
          <scan-code
            :slectProBtn="nonEditable === 1  || getDisabled(fieldAttr)"
            :fieldAttr="fieldAttr"
            :barcodeParams="barcodeParams" 
            @getProduct="handleSelect"
            @sendProduct="scancCodePro">
          </scan-code>
        </template>
      </template>
      <!-- BOM清单产品选择 -->
      <template v-if="moduleName==='bomBill'">
        <template v-if="fieldAttr === 'finishedProduct'">
          <el-button type="text" :disabled="nonEditable === 1  || getDisabled(fieldAttr)" @click="handleSelect()">
            <i class="el-icon-plus"></i>选择产品
          </el-button>
          <!-- 扫码产品 -->
          <scan-code
            :slectProBtn="nonEditable === 1  || getDisabled(fieldAttr)"
            :fieldAttr="fieldAttr"
            :barcodeParams="barcodeParams" 
            @getProduct="handleSelect"
            @sendProduct="scancCodePro">
          </scan-code>
        </template>
        <template v-else>
          <el-button type="text" :disabled="nonEditable === 1  || getDisabled(fieldAttr)" @click="handleSelect()">
            <i class="el-icon-plus"></i>选择产品
          </el-button>
          <!-- 扫码产品 -->
          <scan-code
            :slectProBtn="nonEditable === 1  || getDisabled(fieldAttr)"
            :fieldAttr="fieldAttr"
            :barcodeParams="barcodeParams" 
            @getProduct="handleSelect"
            @sendProduct="scancCodePro">
          </scan-code>
        </template>
      </template>
      <el-dialog title="选择产品" :visible.sync="dialogVisible" :modal="modal" :lock-scroll="false" width="750px">
        <div class="content">
          <!-- 产品分类 -->
          <div class="contentL">
            <template v-if="showClassify">
              <span>产品分类：</span>
              <products-type
              @refresh="getProList">
              </products-type>
            </template>
            <span>搜索：</span>
            <el-input size="small" prefix-icon="el-icon-search" v-model="nameOrNoOrSpecLike" @change="handleSearch" placeholder="搜索产品">
            </el-input> 
          </div>
          <div class="tableOut">
            <table class="selfTable" cellspacing="0" cellpadding="0"border="0">
              <thead>
                <tr>
                  <th>选择</th>
                  <th>图片</th>
                  <th>产品名称</th>
                  <th>编号</th>
                  <th v-if="moduleName !== 'supplier'">规格</th>
                  <th v-if="moduleName === 'supplier'">成本价(元)</th>
                  <th>售价(元)</th>
                  <th>单位</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item,index) in productList">
                  <tr :key="item.id">
                    <td>
                      <el-checkbox v-model="item.inputChecked" @change="selectPro(item)"></el-checkbox><!--change的prevent修饰报错 zpp-->
                    </td>
                    <td>
                      <img
                      :src="item.thumbnail"
                      @click="imgBig(item.thumbnail)"
                      height="48"
                      width="48"/>
                    </td>
                    <td>
                      <el-tooltip class="item"
                      :disabled="item.productName.length>10?false:true"
                      effect="dark" :content="item.productName" placement="top">
                      <p>{{item.productName}}</p>
                      </el-tooltip>
                    </td>
                    <td>
                      <el-tooltip class="item"
                      :disabled="item.productNo.length>5?false:true"
                      effect="dark" :content="item.productNo" placement="top">
                      <p>{{item.productNo}}</p>
                      </el-tooltip>
                    </td>
                    <td v-if="moduleName !== 'supplier'">{{getSingle(item.specification)}}</td>
                    <td v-if="moduleName === 'supplier'">{{item.cost}}</td>
                    <td>{{item.price}}</td>
                    <td>{{item.unit?item.unit:'--'}}</td>
                  </tr>
                  <!-- 多规格 -->
                  <tr
                    v-if="moduleName !== 'supplier' && item.specification && item.specification.length>1 && item.openTr">
                    <td style="background:rgba(243,248,255,1)" colspan="8">
                      <span>选择规格：</span>
                      <el-checkbox v-for="(it,i) in item.specification" :key="it.productId" @change="selectSubPro(item,it)" v-model="it.specChecked"><!--change的prevent修饰报错 zpp-->
                      {{it.specification}}
                      </el-checkbox>
                    </td>
                  </tr>
                </template>
                <tr v-if="haveList"><td colspan="8" style="text-align:center">暂无数据</td></tr>
              </tbody>
            </table>
          </div>  
          <div class="pagination-wrapper clearfix">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <span class="leftSpan" v-if="['contractApi', 'opportunityApi'].indexOf(this.moduleName) > -1">已选产品：{{selectCopyId.length + selectIdArr.length}}</span>
          <span class="leftSpan" v-else>已选产品：{{idArr.length}}</span>
          <el-button type="primary" @click="submitProduct(fieldAttr)">确 定</el-button>
        </div>
      </el-dialog>
   </div>
 </template>
 <script>
  import Vue from 'vue'
  import * as api from 'src/api'
  import { mapGetters, mapActions } from 'vuex'
  import lightBox from 'src/plugins/lightbox'
  import productsType from 'components/fieldtype/products-type.vue'
  import ScanCode from 'components/fieldtype/scan-code.vue' // 扫码
  let lazy
  export default {
    props: ['moduleName', 'form', 'item', 'explains', 'saleExplains', 'nonEditable', 'slectProBtn', 'instockproduct', 'showClassify', 'fieldAttr', 'BillId', 'productType', 'modal', 'selectIdArr'],
    created () {
      // this.moduleName = this.$route.query.moduleName // 获取模块名
      // 从编辑进来(vuex中selectProducts里更新了)
      this.editpage.id = this.$route.query.id // 编辑页ID
      // this.productListSele = this.selectProducts
      // 新建进来清空列表productListSele
      // if (!this.editpage.id) {
      //   this.productListSele = []
      // }
    },
    mounted () {

      // 打开关联弹窗
      if (['contractApi', 'opportunityApi', 'supplier', 'workOrder'].indexOf(this.moduleName) > -1) {
        this.handleSelect()
      }
    },
    data () {
      return {
        dialogVisible: false,
        editpage: {
          id: ''
        },
        productList: [], // 产品列表
        productListSele: [], // 传给父组件处理过的产品
        total: 0,
        pageSize: 6,
        currentPage: 1,
        categoryIdIn: 0, // 分类ID
        nameOrNoOrSpecLike: '', // 搜索值
        inputChecked: false, // 绑定单规格选择框
        specChecked: false, // 绑定多规格选择框
        haveList: false, // 是否多规格
        seleProducts: [], // 传给父组件未处理的产品
        openTr: false, // 是否展开多规格
        selectCopy: [], // 合同机会关联产品已选
        barcodeParams: {} // 产品条码
      }
    },
    computed: {
      ...mapGetters([
        'increaseSelect',
        'decreaseSelect',
        'selectProducts'
      ]),
      // 包含已选产品id的数组
      idArr: {
        get: function () {
          // 编辑页面或者一键采购进来
          if (this.editpage.id !== '' || this.$route.query.type === 'waitPurchaseApi' || this.$route.query.type === 'contractApi') {
            // BOM成品单选特殊
            if (this.fieldAttr !== 'finishedProduct') {
              this.productListSele = this.instockproduct
            }
          }
          // 工单相关
          if (this.moduleName === 'workOrder' && this.selectIdArr) {
            this.productListSele = this.selectIdArr
          }
          return this.productListSele.map(item => item.id)
        },
        // setter
        set: function () {
          this.idArr = []
        }
      },
      selectCopyId: {
        get: function () {
          return this.selectCopy.map(item => item.id)
        },
        // setter
        set: function () {
          this.selectCopyId = []
        }
      }
    },
    methods: {
      ...mapActions([
        'updateSelect',
        'updateAddNumIndex'
      ]),
      // 打开关联弹框,type存在参数代表是扫码过来的
      handleSelect (type) {
        // 出入库单排除其他入库
        if (this.moduleName !== 'purchase' && this.form.type !== '5' && this.moduleName !== 'assemble' && this.moduleName !== 'inventory' && this.moduleName !== 'transfer' && this.moduleName !== 'contractApi' && this.moduleName !== 'opportunityApi' && this.moduleName !== 'supplier' && this.moduleName !== 'workOrder' && this.moduleName !== 'bomBill') {
          this.nameOrNoOrSpecLike = ''
          if (this.BillId.length) {
            this.getTableList(this.BillId)
          } else {
            this.getTableList(this.idArr)
          }
        } else {
          this.nameOrNoOrSpecLike = ''
          this.getTableList()
        }
        if (!type) {
          this.dialogVisible = true
        }
      },

      // getDisabled装配出入库选择产品按钮选了仓库后激活
      getDisabled (field) {
        if ((field === 'outProducts' && this.form.outWarehouseId.id) || (field === 'inProducts' && this.form.intoWarehouseId.id)) {
          return false
        } else if (field === 'finishedProduct' || field === 'materiel') {
          return false
        } else {
          return true
        }
      },

      // 获取产品列表
      getTableList (ids) {
        let url = '/product/getProductsAjax.html'
        let wareId = 0
        // 调拨单调出仓库ID传入
        if (this.moduleName === 'transfer') {
          wareId = this.form.outWarehouseId.id
        } else if (this.moduleName === 'inventory') { // 盘点单仓库id
          wareId = this.form.warehouseId.id
        }
        let params = {
          page: this.currentPage,
          pageSize: this.pageSize,
          categoryIdIn: this.categoryIdIn,
          nameOrNoOrSpecLike: this.nameOrNoOrSpecLike,
          warehouseId: wareId, // 调拨单盘点单需要传,其他时候为0
          idIn: ids || []
        }
        // 采购合同需关联供应商
        if (this.form.supplierId && this.form.supplierId.id && this.moduleName === 'purchase') {
          params.supplierId = this.form.supplierId.id
        }

        // 入库单
        if (this.moduleName === 'instock') {
          params.instockChoose = 1
          // 根据需求关联单据选产品时候要传入入库类型refType和单据refId
          params.refType = this.form.type
          params.refId = this.form.refId.id || 0
        }

        // 出库单(因为入过库的产品才能出库)
        if (this.moduleName === 'outstock') {
          params.warehouseId = this.form.warehouseId.id
          params.fromOutstock = 1
          params.instockChoose = 0
          // 根据需求关联单据选产品时候要传入出库类型refType和单据refId
          params.refType = this.form.type
          params.refId = this.form.refId.id || 0
        }

        // 调拨单、盘点单
        if (this.moduleName === 'transfer' || this.moduleName === 'inventory') {
          params.fromOutstock = 1
          params.instockChoose = 0
        }

        // 装配出库
        if (this.moduleName === 'assemble' && this.fieldAttr === 'outProducts') {
          params.warehouseId = this.form.outWarehouseId.id
          params.fromOutstock = 1
          params.instockChoose = 0
          params.refType = 6
        }

        // 装配入库
        if (this.moduleName === 'assemble' && this.fieldAttr === 'inProducts') {
          params.instockChoose = 1
          // 根据需求装配入库没有关联单据的需要传refType
          params.refType = 6
        }

        // 合同
        if (this.moduleName === 'contractApi') {
          params.isContract = 1
        }

        // 调拨单
        // if (this.moduleName === 'transfer') {
        //   params.warehouseId = this.form.outWarehouseId.id
        // }
        this.barcodeParams = params
        api.post(url, params, (data) => {
          this.productList = data.result
          if (data.result.length === 0) {
            this.haveList = true
          } else {
            this.haveList = false
          }
          this.total = data.pageHelper.rowsCount

          // 加入选中属性
          this.productList.forEach((obj) => {
            Vue.set(obj, 'inputChecked', this.inputChecked)
            Vue.set(obj, 'openTr', this.openTr)
            // 规格里加
            if (obj.specification) {
              obj.specification.forEach((item) => {
                Vue.set(item, 'specChecked', this.specChecked)
              })
            }
          })
          // 保证翻页时候选中状态不变
          // this.$nextTick(() => {
          if ((this.moduleName !== 'contractApi' && this.moduleName !== 'opportunityApi' && this.moduleName !== 'purchase' && this.productType !== 'add') || (this.moduleName === 'supplier' && this.productType === 'add') || (this.moduleName === 'workOrder' && this.productType === 'add')) {
            this.productList.forEach((item) => {
              if (item.specification) {
                item.specification.forEach((ob) => {
                  const index = this.moduleName === 'supplier' ? this.idArr.indexOf(item.id) : this.idArr.indexOf(ob.productId)
                  if (index > -1) {
                    item.inputChecked = true
                    if (item.specification.length) {
                      item.openTr = true
                    } else {
                      item.openTr = false
                    }
                    ob.specChecked = true
                  }

                  // 编辑回显勾上
                  if (this.editpage.id) {
                    this.instockproduct.forEach((it) => {
                      if (ob.productId === it.id) {
                        item.inputChecked = true
                        ob.specChecked = true
                      }
                    })
                  }

                })
              }
            })
          }
          // })
        })
      },
      // 规格列显示
      getSingle (specification) {
        if (specification && specification.length === 1) {
          for (let i in specification) {
            if (specification[i].specification) {
              return specification[i].specification
            }
          }
        } else if (specification && specification.length > 1) {
          return specification.length + '个规格'
        } else {
          return '--'
        }
      },
      // 单规格产品选中
      selectPro (item, code) {
        console.log('item', item)
        // 展开
        if (this.moduleName !== 'supplier') {
          if (item.specification && item.specification.length > 1) {
            if (item.inputChecked) {
              item.openTr = true
            } else {
              item.openTr = false
            }
          }
          // 处理单规格
          if (item.specification && item.specification.length === 1) {
            item.specification.forEach((ob) => {
              // 选中状态
              // if (item.inputChecked) {
              //   ob.specChecked = true
              // } else {
              //   ob.specChecked = false
              // }
              let item2
              if (this.moduleName === 'contractApi' || this.moduleName === 'opportunityApi') {
                item2 = {
                  id: ob.productId,
                  name: item.productName,
                  unit: item.unit,
                  productNo: item.productNo,
                  num: 1,
                  price: ob.price,
                  specification: ob.specification,
                  discount: 100,
                  productPrice: ob.price,
                  totalPrice: ob.price
                }
                // 合同、机会预估成本
                if (ob.estimateCost || ob.estimateCost === 0) {
                  item2.estimateCost = ob.estimateCost
                }
                // 合同产品备注
                if (this.moduleName === 'contractApi') {
                  item2.memo = ''
                }
              } else if (this.moduleName === 'workOrder') {
                item2 = {
                  id: ob.productId,
                  name: item.productName,
                  specification: ob.specification,
                  num: 1,
                  unit: item.unit,
                  price: ob.price
                }
              } else if (this.moduleName === 'bomBill') {
                item2 = {
                  // 价格规格id另外加
                  name: item.productName,
                  unit: item.unit,
                  productNo: item.productNo
                }
                Vue.set(item2, 'id', ob.productId)
                Vue.set(item2, 'specification', ob.specification)
                Vue.set(item2, 'num', ob.num)
                // 扫码
                Vue.set(item2, 'barcode', ob.barcode)
              } else {
                console.log('3443')
                item2 = {
                  // 价格规格id另外加
                  name: item.productName,
                  unit: item.unit,
                  productNo: item.productNo
                }
                Vue.set(item2, 'id', ob.productId)
                Vue.set(item2, 'productPrice', ob.cost)
                Vue.set(item2, 'specification', ob.specification)
                Vue.set(item2, 'stock', ob.stock)
                Vue.set(item2, 'warehouseArray', ob.warehouseArray)
                // 产品成本
                if (typeof ob.productCost === 'number') {
                  Vue.set(item2, 'productCost', ob.productCost)
                  Vue.set(item2, 'hideCost', ob.hideCost)
                }
                // 扫码
                Vue.set(item2, 'barcode', ob.barcode)
                // 备注
                Vue.set(item2, 'memo', ob.memo)
              }

              // 判断产品是否已选
              // this.seleProducts.push(item2)
              const indexOf = this.idArr.indexOf(ob.productId)
              if (this.moduleName === 'contractApi' || this.moduleName === 'opportunityApi') {
                const indexOf2 = this.selectCopyId.indexOf(ob.productId)
                if (item.inputChecked) {
                  if (indexOf2 === -1) {
                    this.selectCopy.push(item2)
                  } else {
                    this.selectCopy.splice(indexOf2, 1)
                  }
                } else {
                  this.selectCopy.splice(indexOf2, 1)
                }
                // 合同机会重复选择
                // if (this.selectCopy) {
                //   this.selectCopy.push(item2)
                // }
              } else if (this.moduleName === 'workOrder') {
                if (indexOf === -1) {
                  this.productListSele.push(item2)
                } else {
                  this.productListSele.splice(indexOf, 1)
                }
              } else if (this.moduleName === 'purchase') {
                if (item.inputChecked || code) {
                  this.seleProducts.push(item2)
                  this.newPro(item2)
                } else {
                  this.seleProducts.splice(indexOf, 1)
                  this.productListSele.splice(indexOf, 1)
                }
              } else {
                if (indexOf === -1) {
                  this.seleProducts.push(item2)
                  // BOM清单成品单规格选择
                  if (this.moduleName === 'bomBill' && this.fieldAttr === 'finishedProduct') {
                    this.productList = this.productList.map((objpro) => {
                      objpro.specification.map((spe) => {
                        if (ob.productId !== spe.productId) {
                          objpro.inputChecked = false
                          spe.specChecked = false
                          objpro.openTr = false
                        } else {
                          objpro.inputChecked = true
                        }
                      })
                      return objpro
                    })
                    this.productListSele = []
                  }
                  this.newPro(item2)
                } else {
                  if (code) {
                    // 扫码重复就数量加1(排除BOM成品)
                    this.productListSele.forEach((obj, h) => {
                      obj.result.forEach((proItem) => {
                        if (proItem.attr === 'num') {
                          if (ob.productId === this.productListSele[h].id) {
                            if (this.moduleName !== 'bomBill' || (this.moduleName === 'bomBill' && this.fieldAttr !== 'finishedProduct')) {
                              // 同步到vuex
                              this.updateAddNumIndex(h)
                              proItem.attrValue = proItem.attrValue + 1
                            }
                          }
                        }
                      })
                    })
                  } else {
                    this.seleProducts.splice(indexOf, 1)
                    this.productListSele.splice(indexOf, 1)
                  }

                }
              }

            })
          }
        } else if (this.moduleName === 'supplier') {
          let item2 = {
            // 供应商选中产品父id
            id: item.id
          }
          const indexOf3 = this.idArr.indexOf(item.id)
          if (indexOf3 === -1) {
            this.productListSele.push(item2)
          } else {
            this.productListSele.splice(indexOf3, 1)
          }
        }
      },
      // 多规格产品选中
      selectSubPro (item, it) {
        let item2
        // 合同、机会产品格式
        if (this.moduleName === 'contractApi' || this.moduleName === 'opportunityApi') {
          item2 = {
            id: it.productId,
            name: item.productName,
            unit: item.unit,
            productNo: item.productNo,
            num: 1,
            price: it.price,
            specification: it.specification,
            discount: 100,
            productPrice: it.price,
            totalPrice: it.price
          }
          // 合同、机会预估成本
          if (it.estimateCost || it.estimateCost === 0) {
            item2.estimateCost = it.estimateCost
          }
        // 工单产品
        } else if (this.moduleName === 'workOrder') {
          item2 = {
            id: it.productId,
            name: item.productName,
            specification: it.specification,
            num: 1,
            unit: item.unit,
            price: it.price
          }
        // BOM清单
        } else if (this.moduleName === 'bomBill') {
          item2 = {
            id: it.productId,
            specification: it.specification,
            num: 1,
            name: item.productName,
            unit: item.unit,
            barcode: it.barcode, // 扫码
            productNo: item.productNo
          }
        } else {
          item2 = {
            // 价格规格id另外加
            id: it.productId,
            productPrice: it.cost,
            specification: it.specification,
            stock: it.stock,
            warehouseArray: it.warehouseArray, // 仓库
            name: item.productName,
            unit: item.unit,
            barcode: it.barcode, // 扫码
            memo: it.memo, // 备注
            productNo: item.productNo
          }
          // 出库、入库成本用到
          if (typeof it.productCost === 'number') {
            item2.productCost = it.productCost
            item2.hideCost = it.hideCost
          }
        }
        // 判断产品是否已选
        const indexOf = this.idArr.indexOf(it.productId)
        if (this.moduleName === 'contractApi' || this.moduleName === 'opportunityApi') {
          const indexOf2 = this.selectCopyId.indexOf(it.productId)
          if (it.specChecked) {
            if (indexOf2 === -1) {
              this.selectCopy.push(item2)
            } else {
              this.selectCopy.splice(indexOf2, 1)
            }
          } else {
            this.selectCopy.splice(indexOf2, 1)
          }
          // 合同机会重复选择
          // if (this.selectCopy) {
          //   this.selectCopy.push(item2)
          // }
        } else if (this.moduleName === 'workOrder') {
          if (indexOf === -1) {
            this.productListSele.push(item2)
          } else {
            this.productListSele.splice(indexOf, 1)
          }
        } else if (this.moduleName === 'purchase') {
          if (it.specChecked) {
            this.seleProducts.push(item2)
            this.newPro(item2)
          } else {
            this.seleProducts.splice(indexOf, 1)
            this.productListSele.splice(indexOf, 1)
          }
        } else {
          if (indexOf === -1) {
            this.seleProducts.push(item2)
            // BOM清单成品多规格选择
            if (this.moduleName === 'bomBill' && this.fieldAttr === 'finishedProduct') {
              this.productList = this.productList.map((objpro) => {
                objpro.specification.map((spe) => {
                  // 去掉单规格选中状态
                  if (item.id !== objpro.id) {
                    objpro.inputChecked = false
                  }
                  if (it.productId !== spe.productId) {
                    spe.specChecked = false
                  } else {
                    spe.specChecked = true
                  }
                })
                return objpro
              })
              this.productListSele = []
            }
            this.newPro(item2)
          } else {
            this.seleProducts.splice(indexOf, 1)
            this.productListSele.splice(indexOf, 1)
          }
        }
      },
      // 对选中的产品中需要精度限制的字段做精度处理
      processPrecision (value, precision) {
        console.log('precision', precision)
        if (typeof precision === 'number') {
          return Number(value.toFixed(precision))
        }
      },
      // 重构选中的产品
      newPro (pro) {
        console.log('pro', pro)
        // 重构数据得到productList用于渲染表格
        // this.seleProducts.map((pro) => {
        let resultItem = {}
        let resultArr = []
        resultItem.id = pro.id
        let explains = []
        // 销售出库只有新建选产品才需要判断用哪个解释
        if (this.form.type === '2' && this.moduleName === 'outstock' && !this.$route.query.id) {
          if (typeof this.item.attrValue.outNumTotal === 'number') {
            // 生成出库单（带数据的新建）
            explains = this.explains
          } else {
            explains = this.saleExplains
          }
        } else {
          // 其他出库单
          explains = this.explains
        }
        if (explains) {
          explains.map((exp) => {
            let attr2 = exp.attr
            let obj = {}
            obj.attr = attr2
            if (pro[attr2] === 0) {
              obj.attrValue = 0
            } else if (!pro[attr2]) {
              obj.attrValue = ''
            } else {
              obj.attrValue = pro[attr2]
            }
            if (attr2 === 'num') {
              obj.attrValue = 1
              obj.attrValue = this.processPrecision(obj.attrValue, exp.decimalPrecision)
            }
            if (attr2 === 'subtotal' || attr2 === 'productPrice') {
              obj.attrValue = pro['productPrice']
              obj.attrValue = this.processPrecision(obj.attrValue, exp.decimalPrecision)
            }
            // 仓库
            if (attr2 === 'warehouse') {
              if (this.fieldAttr === 'outProducts') {
                obj.attrValue = this.form.outWarehouseId
              } else if (this.fieldAttr === 'inProducts') {
                obj.attrValue = this.form.intoWarehouseId
              } else {
                obj.attrValue = this.form.warehouseId
              }
              // 可选择仓库的/其他出入库/盘盈入库/采购入库/合同订单退货入库/销售出库/采购退货出库/盘亏出库
              if (pro.warehouseArray.length) {
                // pro.warehouseArray.map((it) => {
                //   if (this.fieldAttr === 'outProducts') {
                //     if (it.id === this.form.outWarehouseId.id) {
                //       this.stockNum = it.num
                //     }
                //   } else if (this.fieldAttr === 'inProducts') {
                //     if (it.id === this.form.intoWarehouseId.id) {
                //       this.stockNum = it.num
                //     }
                //   } else {
                //     if (it.id === this.form.warehouseId.id) {
                //       this.stockNum = it.num
                //     }
                //   }
                // })
                obj.warehouseArray = pro.warehouseArray
              }
            }
            // 库存
            if (attr2 === 'stock') {
              if (['transfer', 'inventory', 'bomBill'].indexOf(this.moduleName) > -1) {
                obj.attrValue = pro[attr2]
              } else {
                let stockNum = 0 // 库存数量
                // 可选择仓库的/其他出入库/盘盈入库/采购入库/合同订单退货入库/销售出库/采购退货出库/盘亏出库/工单出库
                pro.warehouseArray.map((it) => {
                  if (this.fieldAttr === 'outProducts') {
                    if (it.id === this.form.outWarehouseId.id) {
                      stockNum = it.num
                    }
                  } else if (this.fieldAttr === 'inProducts') {
                    if (it.id === this.form.intoWarehouseId.id) {
                      stockNum = it.num
                    }
                  } else {
                    if (it.id === this.form.warehouseId.id) {
                      stockNum = it.num
                    } else if (!this.form.warehouseId.id) {
                      stockNum = pro[attr2]
                    }
                  }
                })
                obj.attrValue = stockNum
              }
              obj.attrValue = this.processPrecision(obj.attrValue, exp.decimalPrecision)
            }
            // 成本(入库单、出库单)
            if (attr2 === 'productCost') {
              if (['instock', 'outstock', 'assemble'].indexOf(this.moduleName) > -1) {
                let cost = 0 // 成本值
                // 采购入库合同退货入库调拨入库调拨入库采购退货出库产品成本价用（后端给的productCost）
                if ((this.moduleName === 'instock' && ['1', '2', '4'].indexOf(this.form.type) > -1) || (this.moduleName === 'outstock' && this.form.type === '1')) {
                  cost = pro[attr2]
                } else {
                  pro.warehouseArray.map((it) => {
                    if (this.fieldAttr === 'outProducts') {
                      if (it.id === this.form.outWarehouseId.id) {
                        cost = it.productCost
                      }
                    } else if (this.fieldAttr === 'inProducts') {
                      if (it.id === this.form.intoWarehouseId.id) {
                        cost = it.productCost
                      }
                    } else {
                      if (it.id === this.form.warehouseId.id) {
                        cost = it.productCost
                      } else if (!this.form.warehouseId.id) {
                        cost = pro[attr2]
                      }
                    }
                  })
                }
                obj.hideCost = pro.hideCost
                obj.attrValue = cost
                obj.attrValue = this.processPrecision(obj.attrValue, exp.decimalPrecision)
              }
            }
            // 损耗率
            if (attr2 === 'attritionRate') {
              obj.attrValue = 0
            }
            // 销售出库新增的字段写死‘--’
            if (['saleProductPrice', 'saleSubtotal', 'salePrice', 'saleDiscount'].indexOf(attr2) > -1) {
              obj.attrValue = '--'
            }
            if (exp.editable === 1) {
              obj.editable = exp.editable
            }
            if (exp.required) {
              obj.required = exp.required
            }
            if (exp.validate) {
              obj.validate = exp.validate
            }
            if (exp.fieldType === 9) {
              obj.attrValue = []
            }
            if (exp.fieldType) {
              obj.fieldType = exp.fieldType
            }
            // 小数精度
            if (typeof exp.decimalPrecision === 'number') {
              obj.decimalPrecision = exp.decimalPrecision
            }
            obj.attrName = exp.attrName
            obj.isRedundant = exp.isRedundant
            resultArr.push(obj)
          })
        }
        resultItem.result = resultArr
        this.productListSele.unshift(resultItem)
        console.log('格式化后', this.productListSele)
        // })
      },

      // 获得扫码产品后要做的处理
      scancCodePro (item, type) {
        // 因为扫码产品是唯一的，所以调用单规格方法
        let code = 1 // 传code用以区分普通单规格，数量增加那边需要
        this.selectPro(item, code)
        this.submitProduct(type)
      },

      // 图片放大
      imgBig (item) {
        lightBox(item)
      },
      // 每页所显示的条数变更
      handleSizeChange (val) {
        this.pageSize = val
        // 请求产品列表
        this.pushIdIn()
      },
      // 当前分页变更
      handleCurrentChange (val) {
        this.currentPage = val
        if (this.productType) {
          this.productType = 'add'
        }
        // 请求产品列表
        this.pushIdIn()
      },
      // 获得分类组件传来的分类ID
      getProList (value, id) {
        this.categoryIdIn = id
        // 请求产品列表
        this.pushIdIn()
      },
      // 搜索框产品
      handleSearch (query) {
        this.currentPage = 1
        query = query.toString().trim()
        window.clearTimeout(lazy)
        lazy = window.setTimeout(() => {
          // 请求产品列表
          this.pushIdIn()
        }, 500)
      },
      submitProduct (type) {
        // 合同机会和重复选
        if (this.moduleName === 'contractApi' || this.moduleName === 'opportunityApi') {
          this.productListSele = [...this.selectIdArr] // selectIdArr代表编辑进来，有就赋值
          let selectCopyLast = this.productListSele.concat(this.selectCopy) // 新选的与已选的结合
          this.$emit('getProductList', selectCopyLast, 'firstBtn')
          this.$emit('showProduct', 'edit')
        // 工单不可重复选
        } else if (this.moduleName === 'workOrder') {
          this.$emit('getProductList', this.productListSele, 'firstBtn')
          this.$emit('showProduct', 'edit')
        } else {
          // 把修改后的数据传给新建或编辑,其中采购合同可重复添加产品
          if (type === 'outProducts') {
            this.$emit('getProductList', this.productListSele, type) // 出库产品
          } else if (type === 'inProducts') {
            this.$emit('getProductList', this.productListSele, type) // 入库产品
          } else {
            this.$emit('getProductList', this.productListSele, type) // 其他单据产品字段
          }
        }
        this.dialogVisible = false
      },
      // 出入库单除了其他出库和其它入库外/采购退货新建编辑页面，要带上idArr参数
      pushIdIn () {
        if ((this.moduleName === 'instock' && this.form.type && this.form.type !== '5') || (this.moduleName === 'outstock' && this.form.type && this.form.type !== '5') || this.moduleName === 'returnedPurchase') {
          this.getTableList(this.BillId)
        } else {
          this.getTableList()
        }
      }
    },
    components: {
      productsType,
      ScanCode
    },
    watch: {
      instockproduct: {
        handler () {
          if (this.instockproduct.length) {
            this.productListSele = this.instockproduct
          } else {
            this.productListSele = []
          }
        },
        deep: true
      },
      // 监听的窗口关闭事件
      dialogVisible () {
        if (this.dialogVisible === false) {
          this.$emit('closeSelectPro')
          this.currentPage = 1
        }
      }
    }
}
 </script>
 <style lang="less">
  .selectProduct {
    .el-input {
    width: 160px;
    }
    .el-pagination__editor{
      width:60px;
    }
    // .el-dialog {
    //   position: fixed;
    // }
    .el-dialog--small {
      width: 800px !important;
    }
    .el-table {
      .el-table__body tr.current-row > td {
        background: #9bbaca;
      }
      height: 300px;
      overflow-y: auto;
    }
    .el-dialog__header, .el-dialog__footer {
      line-height: 1;
    }
    .el-dialog__body {
      padding: 0;
      padding-left: 10px !important;
    }
    .content {
      width: 99%;
      tr td .cell{overflow: inherit;}
      tr td .cell .el-input{width:90px;}
      .el-dialog__header{padding: 18px 25px;}
      .bottomBtn{display:inline-block;}
      .pagination-wrapper{width:100%;padding-top: 20px;}
      .pagination-wrapper .el-pagination {float:right;}
      .products-type .showValue{height:30px!important;}
    }
    .dialog-footer {
      position: relative;
      .select {
        position: absolute;
        left: 200px;
        top: 4px;
        padding: 6px 15px;
        border-radius: 13px;
      }
    }
  }  
</style>
<style lang="less" scoped>
  .clearfix:after {
    content: " ";
    display: block;
    clear: both;
    height: 0;
  }
  .clearfix {
    zoom: 1;
  }
  .selectProduct {
    &.required{
      &:before {
        content: "*";
        width: 15px;
        display: inline-block;
        color: red;
      }
    }
    .contentL{margin:10px 0;}
    .products-type{display: inline-block;}
    //产品表格
    .tableOut{height:453px;overflow:auto;}
    .selfTable{border: 1px solid #dfe6ec;width:100%;}
    .selfTable tr th{background:#eef1f6;border-bottom: 1px solid #dfe6ec;
      border-right: 1px solid #dfe6ec;padding:3px 10px;
      text-align:left;line-height: 30px;width:100px;}
    .selfTable tr th:nth-of-type(1){width:50px;}
    .selfTable tr th:last-of-type{border-right:none;}
    .selfTable tr td:nth-of-type(2) img{position: relative;top: 2px;}
    .selfTable tr td:nth-of-type(3) p{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    width:150px;}
    .selfTable tr td:nth-of-type(4) p{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    width:80px;
    }
    .selfTable tr td{border-bottom: 1px solid #dfe6ec;border-right: 1px solid #dfe6ec;padding:3px 10px;text-align:left;vertical-align:middle;line-height: 30px;}
    .selfTable tr td:last-of-type{border-right:none;}
    .dialog-footer .leftSpan{float: left;line-height: 30px;}
  }
</style>


// WEBPACK FOOTER //
// select-product.vue?87d481a4